module.exports = __webpack_public_path__ + "assets/menu-24px.55f68494.svg";